/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * moovy-saas-api
 * OpenAPI spec version: 1.0.0
 */
import type { PublicVideoWithSurveyAllOf } from './publicVideoWithSurveyAllOf'
import type { ScenarioVideoWithUrl } from './scenarioVideoWithUrl'

/**
 * 公開動画の詳細。動画紐づきアンケートの設問を同梱する（ADR-0015）。
 */
export type PublicVideoWithSurvey = ScenarioVideoWithUrl & PublicVideoWithSurveyAllOf
